/**
 * Delivery line for [data-impuls-delivery] (offer block): counts down to the same-day dispatch
 * cutoff and shows the delivery window in working days, shifting it after the cutoff and on weekends.
 */

const DAY_NAMES = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];

/** @param {Date} date */
function isWorkingDay(date) {
  const d = date.getDay();
  return d !== 0 && d !== 6;
}

/** @param {Date} from @param {number} days */
function addWorkingDays(from, days) {
  const d = new Date(from);
  let left = days;
  while (left > 0) {
    d.setDate(d.getDate() + 1);
    if (isWorkingDay(d)) left -= 1;
  }
  return d;
}

/** @param {Date} d */
function label(d) {
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${DAY_NAMES[d.getDay()]} ${dd}.${mm}`;
}

function updateDeliveryLines() {
  for (const el of document.querySelectorAll('[data-impuls-delivery]')) {
    if (!(el instanceof HTMLElement)) continue;
    const text = el.querySelector('[data-impuls-delivery-text]');
    if (!text) continue;

    const now = new Date();
    const min = Number(el.dataset.min ?? 1);
    const max = Number(el.dataset.max ?? 3);
    const cutoffHour = el.dataset.cutoff === '' ? NaN : Number(el.dataset.cutoff);
    const cutoff = new Date(now);
    cutoff.setHours(Number.isNaN(cutoffHour) ? 0 : cutoffHour, 0, 0, 0);
    const beforeCutoff = !Number.isNaN(cutoffHour) && isWorkingDay(now) && now < cutoff;

    // Orders after the cutoff (or on weekends) leave one working day later.
    const base = beforeCutoff || Number.isNaN(cutoffHour) ? now : addWorkingDays(now, 1);
    const range = `<strong>${label(addWorkingDays(base, min))} – ${label(addWorkingDays(base, max))}</strong>`;

    if (beforeCutoff) {
      const minutes = Math.max(1, Math.round((cutoff.getTime() - now.getTime()) / 60000));
      const h = Math.floor(minutes / 60);
      const m = minutes % 60;
      const left = h > 0 ? `${h} h ${m} min` : `${m} min`;
      text.innerHTML = `Comandă în <strong class="impuls-offer__timer">${left}</strong> și primești ${range}`;
    } else {
      text.innerHTML = `Comandă acum și primești ${range}`;
    }
  }
}

if (!window.__impulsDeliveryBound && document.querySelector('[data-impuls-delivery]')) {
  window.__impulsDeliveryBound = true;
  updateDeliveryLines();
  setInterval(updateDeliveryLines, 30000);
}
